import { WorkOrderService } from "./../../../services/workorder.service";
import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { VendorPaymentService } from "../../../services/vendor-payment.service";
import { DecimalPipe } from "@angular/common";

@Component({
  selector: "app-workorderpaymentdetails",
  templateUrl: "./workorderpaymentdetails.component.html",
  styleUrls: ["./workorderpaymentdetails.component.scss"],
  providers: [WorkOrderService],
})
export class WorkorderpaymentdetailsComponent implements OnInit {
  vendorPayment: any;
  public balance: number;
  public billIds: string[] = new Array();
  public billLineItems: any[] = new Array();
  public filteredBillLineItems: any[] = new Array();
  constructor(
    @Inject(MAT_DIALOG_DATA) public retreivedData: any,
    public dialogRef: MatDialogRef<WorkorderpaymentdetailsComponent>,
    private _workOrderService: WorkOrderService,
    private decimalPipe: DecimalPipe,
  ) {}

  ngOnInit() {
    this.balance = 0;
    if (this.retreivedData) {
      this.vendorPayment = this.retreivedData;
      this.vendorPayment.paymentLine.forEach((payment) => {
        this.balance += payment.remainingAmount ? payment.remainingAmount : payment.woBillId.billAmount;
        this.billIds.push(payment.woBillId._id);
      });
      this._workOrderService
        .getWoVendorBillsByIds(this.billIds)
        .subscribe((data) => {
          //console.log(data);
          for (let i = 0; i < data.length; i++) {
            for (let j = 0; j < data[i].billLines.length; j++) {
              data[i].billLines[j].billId = data[i]._id;
              this.billLineItems.push(data[i].billLines[j]);
            }
          }
          //console.log(this.billLineItems, "LineItems");
          this.filteredBillLineItems = this.billLineItems;
        });
        this.vendorPayment.balance = this.formatThousandSeperator(this.balance);
        this.vendorPayment.amount = this.formatThousandSeperator(this.vendorPayment.amount);
    }
  }
  formatThousandSeperator(inputNumber) {
    return this.decimalPipe.transform(inputNumber, "1.2-2");
  }
  calculateRemainingAmount(rowData) {
    return rowData.remainingAmount ? rowData.remainingAmount + rowData.paymentAmount : rowData.woBillId.billAmount - rowData.paymentAmount;
  }
  closePopup() {
    this.dialogRef.close(null);
  }
  selectRows(e) {
    e.component.getSelectedRowsData().always((selectedRows) => {
      let selectedIds = selectedRows.map(function (a) {
        return a.woBillId._id;
      });
      this.filteredBillLineItems = this.billLineItems.map(function (a) {
        if (selectedIds.includes(a.billId)) {
          return a;
        }
      });
    });
    //console.log(e.component.getSelectedRowsData(), 'selected')
  }
  intialize(e) {
    e.component.selectAll().fail((s) => console.log(s, "error"));
  }
}
